import { trackPageView } from './pixel';

export const CONSENT_KEY = 'smt_cookie_consent';
const MAX_AGE_MS = 15552000000; // 180 jours (même valeur que public/index.html)
export const OPEN_SETTINGS_EVENT = 'smt:open-cookie-settings';

export const getConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(CONSENT_KEY) || 'null');
    return c && c.v === 1 && Date.now() - c.at < MAX_AGE_MS ? c : null;
  } catch (_e) {
    return null;
  }
};

const clearMetaCookies = () => {
  const host = window.location.hostname;
  const domains = ['', host, `.${host}`, `.${host.split('.').slice(-2).join('.')}`];
  ['_fbp', '_fbc'].forEach((name) => domains.forEach((d) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d ? `; domain=${d}` : ''}`;
  }));
};

export const saveConsent = (ads) => {
  const had = getConsent()?.ads === true;
  localStorage.setItem(CONSENT_KEY, JSON.stringify({ v: 1, ads: !!ads, at: Date.now() }));
  if (ads && typeof window.smtLoadPixel === 'function') {
    window.smtLoadPixel();
    trackPageView();
  } else if (!ads) {
    clearMetaCookies();
    if (had) window.location.reload(); // unload the already-running pixel
  }
};

export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT));
